import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import { ISuggestionModel } from 'office-ui-fabric-react/lib/Pickers';
import { isStringNullOrWhiteSpace } from 'owa-strings';

export default function createGenericItem(
    name: string,
    currentValidationState: boolean
): ISuggestionModel<FindRecipientPersonaType> {
    if (!isStringNullOrWhiteSpace(name)) {
        const persona: FindRecipientPersonaType = {
            EmailAddress: {
                MailboxType: 'OneOff',
                RoutingType: 'SMTP',
                EmailAddress: name,
                Name: name,
            },
        };

        return {
            selected: false,
            item: persona,
        };
    } else {
        return null;
    }
}
